import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Badge,
  Card,
  Button,
  Form,
} from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import { catchAsync, checkResponse } from "../../../../utilities/utilities";
import {
  HOTELDETAILS,
  AVAILABITYSTATUSHOTEL,
} from "../../../../services/ApiCalls";
import moment from "moment";
import Loader from "../../../../components/Common/Loader";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

const ManageHotelDetail = () => {
  const availability = ["Open", "Closed"];
  const [loader, setLoader] = useState(false);
  const [serviceData, setServiceData] = useState({});
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const [selectedPin, setSelectedPin] = useState(null);
  const { id } = useParams();
  const { t } = useTranslation();

  const getData = catchAsync(async () => {
    setLoader(true);
    const resHotel = await HOTELDETAILS(id);

    checkResponse({ res: resHotel, setData: setServiceData, setLoader });

    if (resHotel?.data?.data?.availability) {
      setSelectedPin(resHotel.data.data.availability);
    }
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const handleAssign = async () => {
    if (!selectedPin) {
      toast.error(
        t("common.selectPinError", "Please select a Availabity first!")
      );
      return;
    }

    const payload = {
      id: id,
      status: selectedPin,
    };

    const res = await AVAILABITYSTATUSHOTEL(payload);
    if (res?.data?.status === "success") {
      toast.success(res.data.message);
      setServiceData((prev) => ({ ...prev, pinStatus: selectedPin }));
      getData();
    } else {
      toast.error(
        res?.data?.message || t("common.error", "Something went wrong!")
      );
    }
  };

  console.log("serviceData", serviceData);

  return (
    <>
      {loader && <Loader />}
      <section className="serviceDetail py-3 position-relative">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to={`/hotel?page=${page}`}
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("manageHotel.detailTitle", "Hotel Detail")}
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Card className="p-3 shadow-sm rounded">
                <h5 className="fw-bold mb-3">
                  {t("manageHotel.hotelImages")}
                </h5>

                {serviceData?.hotelImages?.length > 0 ? (
                  <Slider
                    dots={true}
                    infinite={serviceData.hotelImages.length > 1}
                    speed={500}
                    slidesToShow={Math.min(serviceData.hotelImages.length, 2)}
                    slidesToScroll={1}
                    arrows={serviceData.hotelImages.length > 1}
                    responsive={[
                      {
                        breakpoint: 1024,
                        settings: {
                          slidesToShow: Math.min(serviceData.hotelImages.length, 3),
                        },
                      },
                      {
                        breakpoint: 768,
                        settings: {
                          slidesToShow: Math.min(serviceData.hotelImages.length, 2),
                        },
                      },
                      {
                        breakpoint: 480,
                        settings: {
                          slidesToShow: 1,
                        },
                      },
                    ]}
                  >
                    {serviceData.hotelImages.map((src, i) => (
                      <div key={i} className="p-2">
                        <img
                          src={src?.link}
                          alt={`room-${i}`}
                          className="rounded shadow-sm"
                          style={{
                            width: "100%",
                            height: 200,
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <p className="text-muted">
                    {t("common.noImages", "No Images")}
                  </p>
                )}
              </Card>
            </Col>

            <Col lg="6" className="my-2">
              <Card className="p-3 shadow-sm rounded">
                <div className="d-flex align-items-center mb-3">
                  <img
                    src={serviceData?.userId?.profileImage}
                    alt="Admin Profile"
                    className="rounded-circle me-3"
                    style={{ width: 60, height: 60, objectFit: "cover" }}
                  />
                  <div>
                    <h5 className="mb-0">{serviceData?.userId?.name}</h5>
                    <small className="text-muted">
                      {serviceData?.userId?.email}
                    </small>
                  </div>
                </div>
                <ul className="list-unstyled mb-0">
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.hotelName", "Hotel Name")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.hotelName ||
                        t("manageHotel.placeholders.notAvailable", "-")}
                    </span>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.hotelId", "Hotel ID")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.hotelId || "------"}
                    </span>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.pinStatus")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.pinStatus?.label || "------"}
                    </span>
                  </li>

                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.address")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.address ||
                        t("manageHotel.placeholders.notAvailable", "-")}
                    </span>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.phone", "Phone")}:
                    </strong>
                    <span className="text-muted w-50">
                      +{serviceData?.countryCode} {serviceData?.mobileNumber}
                    </span>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.city", "City")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.city}{" "}
                    </span>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.availablity")}:
                    </strong>
                    <Badge
                      bg={
                        serviceData?.availability === "Open"
                          ? "success"
                          : "secondary"
                      }
                    >
                      {serviceData?.availability}
                    </Badge>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.status", "Status")}:
                    </strong>
                    <Badge
                      bg={
                        serviceData?.status === "Active" ? "success" : "danger"
                      }
                    >
                      {serviceData?.status}
                    </Badge>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.totalRooms", "Total Rooms")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.totalRoom ||
                        t("manageHotel.placeholders.zero", "0")}
                    </span>
                  </li>
                  {/* <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.checkInTime", "Check In Time")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.checkInTime
                        ? moment(serviceData.checkInTime, "HH:mm").format(
                          "hh:mm A"
                        )
                        : t("manageHotel.placeholders.zero", "0")}
                    </span>
                  </li>

                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.checkOutTime", "Check Out Time")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.checkOutTime
                        ? moment(serviceData.checkOutTime, "HH:mm").format(
                          "hh:mm A"
                        )
                        : t("manageHotel.placeholders.zero", "0")}
                    </span>
                  </li> */}
                  {/* <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.displayType")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.displayPrice?.type}
                    </span>
                  </li> */}
                  {/* <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.displayPrice")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.displayPrice?.price}
                    </span>
                  </li> */}

                   

                   <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.googleRating","Google Rating")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.googleRating?.rating}/5
                    </span>
                  </li>
                    <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.googleReviewCount","Google Review Count")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.googleRating?.reviewCount}
                    </span>
                  </li>
                  
                  {/* <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.checkOutTime", "Check Out Time")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.checkOutTime
                        ? moment(serviceData.checkOutTime, "HH:mm").format(
                          "hh:mm A"
                        )
                        : t("manageHotel.placeholders.zero", "0")}
                    </span>
                  </li> */}

                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.createdAt", "Created At")}:
                    </strong>
                    <span className="text-muted w-50">
                      {moment(serviceData?.createdAt).format(
                        "DD-MM-YYYY, HH:mm"
                      )}
                    </span>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.description", "Description")}:
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.description}
                    </span>
                  </li>
                </ul>

                <Form.Group className="mt-3">
                  <Form.Label>
                    {t("manageHotel.columns.assignAvailabity")}
                  </Form.Label>
                  <Form.Select
                    value={selectedPin || ""}
                    onChange={(e) => setSelectedPin(e.target.value)}
                  >
                    <option value="">
                      {t("common.selectPin", "-- Select --")}
                    </option>
                    {availability.map((status, idx) => (
                      <option key={idx} value={status}>
                        {status}
                      </option>
                    ))}
                  </Form.Select>
                  <Button className="mt-3" onClick={handleAssign}>
                    {t("manageHotel.columns.update", "Update")}
                  </Button>
                </Form.Group>
              </Card>
            </Col>

            {/* <Col lg="6" className="my-2">
              <div className="d-flex flex-column gap-4">
                <Card className="p-3 shadow-sm rounded">
                  <h5 className="fw-bold mb-3">
                    {t("manageHotel.images", "Hotel Images")}
                  </h5>
                  <Row>
                    {serviceData?.images?.length > 0 ? (
                      serviceData.images.map((src, i) => (
                        <Col xs={6} className="mb-2" key={i}>
                          <img
                            src={src}
                            alt={`hotel-${i}`}
                            className="rounded shadow-sm"
                            style={{
                              width: "100%",
                              height: 150,
                              objectFit: "cover",
                            }}
                          />
                        </Col>
                      ))
                    ) : (
                      <p className="text-muted">
                        {t("common.noImages", "No Images")}
                      </p>
                    )}
                  </Row>
                </Card>
                <Card className="p-3 shadow-sm rounded">
                  <strong className="text-bold">Hotel Admin Detail</strong>
                  <Col lg="12" className="my-2">
                    <div
                      className="imgWrp text-center mx-auto"
                      style={{ maxWidth: "max-content" }}
                    >
                      <img
                        src={serviceData?.userId?.profileImage}
                        style={{ height: 140, width: 140 }}
                        alt=""
                        className="img-fluid rounded-circle object-fit-cover"
                      />
                    </div>
                  </Col>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t("manageHotel.columns.hotelAdmin", "Hotel Admin:")}
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.userId?.name}
                    </span>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t(
                        "manageHotel.columns.hotelAdminEmail",
                        "Hotel Admin Email:"
                      )}
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.userId?.email}
                    </span>
                  </li>
                  <li className="py-2 d-flex">
                    <strong className="w-50">
                      {t(
                        "manageHotel.columns.hotelAdminMobile",
                        "Hotel Admin Mobile:"
                      )}
                    </strong>
                    <span className="text-muted w-50">
                      {serviceData?.userId?.mobileNumber}
                    </span>
                  </li>
                </Card>
              </div>
            </Col> */}

            <Col lg="6">
              <Col className="my-2">
                <Card className="p-3 shadow-sm rounded">
                  <h5 className="fw-bold mb-3">
                    {t("manageHotel.hotelAmenities")}
                  </h5>
                  <Row>
                    {serviceData?.amenities?.length > 0 ? (
                      serviceData.amenities.map((item, i) => (
                        <Col xs={6} md={6} lg={6} className="mb-3" key={i}>
                          <div className="d-flex align-items-center gap-2 border rounded p-2 bg-white h-100">
                            <img
                              src={item.imgUrl}
                              alt={item.name}
                              style={{
                                width: 40,
                                height: 40,
                                objectFit: "contain",
                                borderRadius: "6px",
                              }}
                              onError={(e) => {
                                e.target.style.display = "none";
                                e.target.nextSibling.style.marginLeft = "0";
                              }}
                            />
                            <span
                              className="small fw-medium text-truncate"
                              title={item.name}
                            >
                              {item.name}
                            </span>
                          </div>
                        </Col>
                      ))
                    ) : (
                      <Col xs={12}>
                        <p className="text-muted text-center py-3 mb-0">
                          <i className="bi bi-inbox me-2"></i>
                          {t("common.noAmenities", "No amenities available")}
                        </p>
                      </Col>
                    )}
                  </Row>
                </Card>
              </Col>
              <Col className="my-2">
                <Card className="p-3 shadow-sm rounded">
                  <h5 className="fw-bold mb-3">
                    {t("manageHotel.highlight")}
                  </h5>
                  <Row>
                    {serviceData?.highLight?.length > 0 ? (
                      serviceData.highLight.map((item, i) => (
                        <Col xs={6} md={6} lg={6} className="mb-3" key={i}>
                          <div className="d-flex align-items-center gap-2 border rounded p-2 bg-white h-100">


                            <span
                              className="small fw-medium text-truncate"
                              title={item.text}
                            >
                              {item.text}
                            </span>
                          </div>
                        </Col>
                      ))
                    ) : (
                      <Col xs={12}>
                        <p className="text-muted text-center py-3 mb-0">
                          <i className="bi bi-inbox me-2"></i>
                          {t("manageHotel.noHighlight")}
                        </p>
                      </Col>
                    )}
                  </Row>
                </Card>
              </Col>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageHotelDetail;
